import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

// GET UNAVAILABLE DATES FOR TIME SELECTION
export const getUnavailableDates = createAsyncThunk(
  'unavailableDates/getUnavailableDates',
  async (payload, thunkAPI) => {
    const { locationId, startDate, endDate, service } = payload;

    let url = `/unavailable-datetime`;

    if (locationId) {
      if (url.includes('?')) {
        url += `&location_id=${locationId}`;
      } else {
        url += `?location_id=${locationId}`;
      }
    }

    if (startDate) {
      if (url.includes('?')) {
        url += `&start_date=${startDate}`;
      } else {
        url += `?start_date=${startDate}`;
      }
    }

    if (endDate) {
      if (url.includes('?')) {
        url += `&end_date=${endDate}`;
      } else {
        url += `?end_date=${endDate}`;
      }
    }

    if (service) {
      if (url.includes('?')) {
        url += `&service=${service}`;
      } else {
        url += `?service=${service}`;
      }
    }

    try {
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Failed to get unavailable dates!';
      return thunkAPI.rejectWithValue(message);
    }
  },
);
